import React, { useEffect, useState } from 'react';
import './Styles/AnalyticsMain.css';
import SummaryVisit from '../../Components/AnalyticsMain/SummaryVisit';
import DistVisitByDay from '../../Components/AnalyticsMain/DistVisitByDay';
import InflowByChannel from '../../Components/AnalyticsMain/InflowByChannel';
import InflowByDevice from '../../Components/AnalyticsMain/InflowByDevice';
import InflowKeyword from '../../Components/AnalyticsMain/InflowKeyword';
import PopularPage from '../../Components/AnalyticsMain/PopularPage';
import { useLoadingState } from '../../context/LoadingContext';
import { DataApi } from '../../API';
import { useSelector } from 'react-redux';

function AnalyticsMain(props) {
  const currentSite = useSelector((state) => state.currentSite);
  const period = useSelector((state) => state.period);
  const comparePeriod = useSelector((state) => state.comparePeriod);
  const [, setLoading] = useLoadingState(true);
  const [PVData, setPVData] = useState([]);
  const [UVData, setUVData] = useState([]);
  const [PPData, setPPData] = useState([]);
  const [IKData, setIKData] = useState([]);
  const [DeviceData, setDeviceData] = useState([]);
  const [UrlData, setUrlData] = useState([]);
  const [graphData, setGraphData] = useState({});
  useEffect(() => {
    try {
      setLoading(true);
      const getApi = async () => {
        /**
         * 페이지 뷰
         * ---
         */
        const pvData = await DataApi.getPV(
          currentSite.script_code,
          period,
          comparePeriod
        );
        const pvRowData = await DataApi.getPVRow(
          currentSite.script_code,
          period
        );
        setPVData(pvData);
        /**
         * 방문현황 요약
         * ---
         */
        const uvData = await DataApi.getUV(
          currentSite.script_code,
          period,
          comparePeriod
        );
        const uvRowData = await DataApi.getUVRow(
          currentSite.script_code,
          period
        );
        setUVData(uvData);
        const graphFormatData = await formatGraphData(uvRowData, pvRowData);
        setGraphData({
          title: '일별 방문현황',
          XAxis: 'date',
          info: graphFormatData.info,
          graphData: graphFormatData.graphDataByDay,
        });
        /**
         * 유입검색어
         * ----
         */
        const keywordData = await DataApi.getKeyword(
          currentSite.script_code,
          period,
          comparePeriod
        );
        setIKData(keywordData);
        /**
         * 인기페이지
         * ----
         */
        const PPData = await DataApi.getPopularPage(
          currentSite.script_code,
          period
        );
        setPPData(PPData);
        /**
         * 디바이스 조회
         * ----
         */
        const deviceData = await DataApi.getDevice(
          currentSite.script_code,
          period,
          comparePeriod
        );
        setDeviceData(deviceData);
        /**
         * 검색채널별 조회
         * ----
         */
        const UrlData = await DataApi.getIncomeUrl(
          currentSite.script_code,
          period,
          comparePeriod
        );
        setUrlData(UrlData);
      };
      getApi();
    } catch (e) {
      console.error(e.message);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }
  }, [currentSite, period, comparePeriod, setLoading]);

  props.setCurrentPage(props.pageTitle);
  return (
    <>
      <SummaryVisit data={{ PVData: PVData, UVData: UVData }} />
      <DistVisitByDay data={graphData} />
      <div className="c2-1">
        <div className="c2-1-1">
          <InflowByChannel data={UrlData} />
          <InflowByDevice data={DeviceData} />
        </div>
        <div className="c2-1-2">
          <InflowKeyword data={IKData} />
        </div>
      </div>
      <PopularPage data={PPData} />
    </>
  );
}

export default AnalyticsMain;

const formatGraphData = (UVData, PVData) => {
  const graphData = [];
  const format = {
    new_visitor: 0,
    re_visitor: 0,
    all_pv: 0,
    new_pv: 0,
    re_pv: 0,
  };
  if (UVData && PVData && UVData.length > 0 && PVData.length > 0) {
    for (let i = 0; i < UVData?.length; i++) {
      format.new_visitor += UVData[i]?.new_visitor?.value;
      format.re_visitor += UVData[i]?.re_visitor?.value;
      format.new_pv += PVData[i]?.new_pv?.value;
      format.re_pv += PVData[i]?.re_pv?.value;
      format.all_pv += PVData[i]?.all_pv?.value;
    }

    for (let i = 0; i < UVData?.length; i++) {
      const item = {
        date: UVData[i]?.date,
        visitNum: UVData[i]?.all_visitor?.value,
        visitCnt: UVData[i]?.visit_times?.value,
        newVisitNum: UVData[i]?.new_visitor?.value,
        reVisitNum: UVData[i]?.re_visitor?.value,
        pageView: PVData[i]?.all_pv?.value,
      };
      graphData.push(item);
    }
  }
  return {
    graphDataByDay: graphData,
    info: format,
  };
};
